<template>
  <div class="pt-5 align-items-center justify-content-center">
    <div class="card-login p-4 text-center">
      <img :src="`img/svg/Logo_Grupo_Mass.svg`" alt="Logo de la empresa" class="img-fluid">
    </div>
  </div>
</template>

<script>
  import { ref } from 'vue'

  export default {
    name: 'HomeView',
    setup() {
      return {
        // urlBase,
      };
    },
  };
</script>

